import {Ref, MutableRefObject, useState} from "react";

type ReactRef<T> = Ref<T>;

/* eslint-disable @typescript-eslint/ban-ts-comment, no-param-reassign */
function assignRef<T>(ref: ReactRef<T>, value: T | null): ReactRef<T> {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref != null) {
    // @ts-ignore
    ref.current = value;
  }
  return ref;
}
/* eslint-enable */

function useCallbackRef<T>(
  initialValue: T | null,
  callback: (newValue: T | null, lastValue: T | null) => void
): MutableRefObject<T | null> {
  const [ref] = useState(() => ({
    // value
    value: initialValue,
    // last callback
    callback,
    // "memoized" public interface
    facade: {
      get current() {
        return ref.value;
      },
      set current(value) {
        const last = ref.value;
        if (last !== value) {
          ref.value = value;
          ref.callback(value, last);
        }
      },
    },
  }));
  // update callback
  ref.callback = callback;

  return ref.facade;
}

export function useMergeRefs<T>(
  refs: ReactRef<T>[],
  defaultValue = null
): React.MutableRefObject<T | null> {
  return useCallbackRef<T>(defaultValue, (newValue) =>
    refs.forEach((ref) => assignRef(ref, newValue))
  );
}
